import { render, staticRenderFns } from "./CmgManageGroupOrderBanner.vue?vue&type=template&id=73f891b2&scoped=true&lang=pug&"
import script from "./cmg-manage-group-order-banner.ts?vue&type=script&lang=ts&"
export * from "./cmg-manage-group-order-banner.ts?vue&type=script&lang=ts&"
import style0 from "./CmgManageGroupOrderBanner.vue?vue&type=style&index=0&id=73f891b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f891b2",
  null
  
)

export default component.exports